import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Legal.css';

function Cancellation() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length <= 1) {
      window.close();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="btn-go-back" onClick={handleGoBack}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"/>
            <polyline points="12 19 5 12 12 5"/>
          </svg>
          Close
        </button>
        <h1>Cancellation & Refund Policy</h1>
        <p className="last-updated">Last updated: November 2024</p>

        <section className="legal-section">
          <h2>Cancellation Policy</h2>

          <div className="policy-card">
            <h3>Free Cancellation</h3>
            <p>
              Cancel <strong>12 hours or more</strong> before your scheduled appointment
              at no charge.
            </p>
          </div>

          <div className="policy-card warning">
            <h3>Late Cancellation</h3>
            <p>
              Cancellations made <strong>less than 3 hours</strong> before the appointment
              are subject to a <strong>$30 cancellation fee</strong>.
            </p>
          </div>

          <div className="policy-card danger">
            <h3>No-Show</h3>
            <p>
              If you are not present at the scheduled time and location without prior
              cancellation, the <strong>full service amount may be charged</strong>.
            </p>
          </div>
        </section>

        <section className="legal-section">
          <h2>How to Cancel</h2>
          <p>To cancel or reschedule your appointment, please contact us as soon as possible:</p>
          <ul>
            <li>Call or text: <a
              href="tel:+19168188494"
              data-event="cta_call_click"
              data-cta-location="cancellation_how_to"
            >(916) 818-8494</a></li>
            <li>Email: <a href="mailto:info@norcalmobileoilchange.com">info@norcalmobileoilchange.com</a></li>
          </ul>
          <p>
            Please provide your name and appointment date/time when cancelling.
          </p>
        </section>

        <section className="legal-section">
          <h2>Company Cancellation</h2>
          <p>NorCal Mobile Oil Change reserves the right to cancel or reschedule a service due to:</p>
          <ul>
            <li>Severe weather conditions that make service unsafe</li>
            <li>Incorrect vehicle information provided by the customer</li>
            <li>Unsafe service location</li>
            <li>Vehicle condition that prevents safe service</li>
            <li>Emergency situations</li>
          </ul>
          <p>
            In these cases, we will contact you to reschedule at no additional charge.
          </p>
        </section>

        <section className="legal-section">
          <h2>Refund Policy</h2>

          <h3>Full Refund or Free Correction Provided If:</h3>
          <ul>
            <li>A workmanship error is proven (within 7 days of service)</li>
            <li>Wrong oil or filter was used by our mistake</li>
            <li>Service was not completed as agreed</li>
          </ul>

          <h3>Refund is NOT Provided If:</h3>
          <ul>
            <li>Customer provided incorrect vehicle make, model, or engine type</li>
            <li>Service location prohibits automotive work (HOA rules, parking regulations, etc.)</li>
            <li>Issues are caused by pre-existing damage or vehicle condition</li>
            <li>Customer cancelled late or was a no-show</li>
            <li>Customer is not satisfied for reasons unrelated to our service quality</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>7-Day Workmanship Guarantee</h2>
          <p>
            All our services come with a <strong>7-day workmanship guarantee</strong>.
            If you experience any issues related to our work within 7 days of service,
            contact us immediately and we will make it right at no additional cost.
          </p>
          <p>This guarantee covers:</p>
          <ul>
            <li>Oil leaks caused by improper filter installation</li>
            <li>Incorrect oil type used</li>
            <li>Drain plug issues caused by our service</li>
          </ul>
          <p>This guarantee does NOT cover:</p>
          <ul>
            <li>Pre-existing mechanical issues</li>
            <li>Damage caused by the customer or third parties</li>
            <li>Normal wear and tear</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Dispute Resolution</h2>
          <p>
            If you have any concerns about our service or believe you are entitled to a refund,
            please contact us directly. We are committed to resolving any issues fairly and promptly.
          </p>
        </section>

        <section className="legal-section contact-section">
          <h2>Contact Us</h2>
          <p>For cancellations, refunds, or any questions:</p>
          <ul>
            <li>Phone: <a
              href="tel:+19168188494"
              data-event="cta_call_click"
              data-cta-location="cancellation_contact"
            >(916) 818-8494</a></li>
            <li>Email: <a href="mailto:info@norcalmobileoilchange.com">info@norcalmobileoilchange.com</a></li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default Cancellation;
